/*
 * @Date: 2022-07-14 14:25:44
 * @LastEditTime: 2022-09-22 15:20:42
 * @Description: file content
 */
import axios from 'axios';
import qs from 'qs';

const service = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Requested-With': 'XMLHttpRequest',
    'Cache-control': 'no-cache',
  },
});

service.interceptors.request.use(config => {
  const { method, headers } = config;
  if (
    method.toUpperCase() === 'POST' &&
    headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data);
  }
  return config;
});

service.interceptors.response.use(
  response => response.data,
  error => {
    const { response = {} } = error;
    const { status, data = {}, statusText } = response;
    const errorMsg = data.error_msg || statusText;

    if (status === 401) {
      // do stuff
    } else {
      console.error(errorMsg);
    }

    return Promise.reject(error, data);
  }
);

export default service;
